import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Send Contact Us form
export const Create = createAsyncThunk(
  "/website/volunteer-detail/volunteer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.VolunteerDetail.Volunteer, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAll = createAsyncThunk(
  "/website/volunteer-detail/volunteer-get",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.VolunteerDetail.GetVolunteer}?name=${filter?.name ||
        ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
        IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSingle = createAsyncThunk(
  "/website/volunteer-detail/volunteer-get-s",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.VolunteerDetail.GetVolunteer}/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "volunteer",
  initialState: {
    data: [],
    single: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single = action.payload.data;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = Slice.actions;
export default Slice.reducer;
